import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { LOGIN_MODAL_TYPE } from 'Services/User';

import Modal from '@Components/Common/Modal';
import TX from '@Components/Common/Text';
import Button from '@Components/Common/Button';

const NoticeNot2033UserModal = ({ isNoticeNot2033UserModalVisible, handleCloseModalClick, label }) => {
  const handleCloseButtonClick = () => handleCloseModalClick(LOGIN_MODAL_TYPE.NOT_SEOUL_2033_USER);

  return (
    <Modal visible={isNoticeNot2033UserModalVisible} handleCloseButtonClick={handleCloseButtonClick}>
      <ModalContentContainer>
        <NoticeText>
          {label}
          <br />
          서울 2033 게임에서 로그인 한 계정으로 <br />
          진행해 주세요.
        </NoticeText>
      </ModalContentContainer>

      <Button text="확인" onClick={handleCloseButtonClick} />
    </Modal>
  );
};

NoticeNot2033UserModal.propTypes = {
  isNoticeNot2033UserModalVisible: PropTypes.bool.isRequired,
  handleCloseModalClick: PropTypes.func.isRequired,
};

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 96px;

  margin-bottom: 16px;
`;

const NoticeText = styled(TX.BodyM)`
  color: ${({ theme }) => theme.colors.ui_on_2};
  text-align: center;

  line-height: 24px;
`;

export default NoticeNot2033UserModal;
